import * as global from './_views-view-unformatted.mjs';
import * as ug_programmes from './_views-view-unformatted--ug-programmes.mjs';
import * as pg_programmes from './_views-view-unformatted--pg-programmes.mjs';
import * as offers from './_views-view-unformatted--offers.mjs';
import * as basic_info from './_views-view-unformatted--5_kinds_of_basic_info_local_non_jupas_.mjs';
import * as ar_scholarship from './_views-view-unformatted--ar-scholarship.mjs';
